module.exports = __webpack_public_path__ + "static/img/role.df25220.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/kc/role.png
// module id = 47m+
// module chunks = 7